// removed by extract-text-webpack-plugin
module.exports = {"this":"_5VPc0foEOSj87J1bE4APQ","desSize":"_2Y45HbXN_Vx3m3zh8c7Jzj","moneySize":"_3j7rd4cUVZ3kHG9AEZaywq","moneyColor":"_1NwVM0kfm7SKaZ6OPoRVcg","pepColor":"_1bVxL6zrnO91wbhn_Iw74t","lineDiv":"_3JKBuEX3oFmc6WwJGf7uQ5","inCome":"_1nJ8pmVoau3c2ojlVNT6Eb","minDiv":"_2RwuhNN5RjasI3bIhH7x73"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/ui/Draw/IncomeCalculator.scss
// module id = 938
// module chunks = 12